<script setup>
import { computed, ref, watch } from 'vue';
import FormInputLabel from '@/components/Shared/Form/Input/Label.vue';
import FormInputError from '@/components/Shared/Form/Input/Error.vue';
import { uniqueId } from 'lodash';

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  options: {
    type: Array,
    required: true,
  },
  error: {
    type: String,
    default: null,
  },
  modelValue: {
    type: Array,
    default: () => [],
  },
  columns: {
    type: Number,
    default: null,
  },
});

const uniqueIdCheckbox = uniqueId('checkbox-');

const emit = defineEmits(['update:modelValue']);

const selectedOptions = ref(props.modelValue);

const gridColumns = computed(() => {
  return `repeat(${props.columns}, 1fr)`;
});

watch(
  () => selectedOptions.value,
  newValue => {
    emit('update:modelValue', newValue);
  },
);

watch(
  () => props.modelValue,
  newValue => {
    selectedOptions.value = newValue;
  },
);
</script>

<template>
  <div class="form-group">
    <form-input-label v-if="label" :for="$attrs.id" :value="label" :required="$attrs.required" />
    <div :class="columns === null ? '' : 'grid-checkbox'">
      <div v-for="option in options" :key="option" class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          :id="`${uniqueIdCheckbox}-${option}`"
          :value="option"
          :class="{ 'is-invalid': error }"
          v-model="selectedOptions"
        />
        <label class="form-check-label" :for="`${uniqueIdCheckbox}-${option}`">{{ option }}</label>
      </div>
    </div>
    <form-input-error v-if="error" :error-message="error" />
  </div>
</template>

<style scoped>
.grid-checkbox {
  display: grid;
  grid-template-columns: v-bind(gridColumns);
  grid-gap: 0.5rem;
}
</style>
